import React from 'react';
import ReactDOM from 'react-dom';
import opsComponents from '../bundles/ops';
import { tapiContainers } from '../bundles/tapi';
window.React = React;
window.ReactDOM = ReactDOM;
export var componentRender = function(componentName, props, domEl) {
    ReactDOM.render(React.createElement(opsComponents[componentName] || tapiContainers[componentName], props), domEl);
};
window.componentRender = componentRender;
